import { AvailableOrInstalledConnection } from 'app/connections/types'

export const isConfigured = (connection: AvailableOrInstalledConnection) => {
  switch (connection.name) {
    case 'criteo':
    case 'dv360':
      return connection.config.advertisers.length > 0
    case 'facebook':
    case 'googleAdwords':
      return connection.config.accounts.length > 0
    case 'googleAnalytics':
      return !!connection.config.propertyId
    default:
      return true
  }
}
